module.exports = __webpack_public_path__ + "img/lost.c76e5aea.png";